"use client";

import React from "react";
import Link from "next/link";
import { useUser, useClerk } from "@clerk/nextjs";

export default function Navbar() {
  const { isSignedIn, user } = useUser();
  const { signOut } = useClerk();

  return (
    <nav className="bg-indigo-600 shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link href="/" className="flex-shrink-0 flex items-center">
              <span className="text-white text-xl font-bold">Christian Bible App</span>
            </Link>
            <div className="hidden md:ml-6 md:flex md:space-x-8">
              <Link 
                href="/" 
                className="text-white hover:bg-indigo-500 px-3 py-2 rounded-md text-sm font-medium"
              >
                Home
              </Link>
              {isSignedIn && (
                <>
                  <Link 
                    href="/dashboard" 
                    className="text-white hover:bg-indigo-500 px-3 py-2 rounded-md text-sm font-medium"
                  >
                    Dashboard
                  </Link>
                  <Link 
                    href="/user/Bible" 
                    className="text-white hover:bg-indigo-500 px-3 py-2 rounded-md text-sm font-medium"
                  >
                    Bible Study
                  </Link>
                  <Link 
                    href="/user/notes" 
                    className="text-white hover:bg-indigo-500 px-3 py-2 rounded-md text-sm font-medium"
                  >
                    My Notes
                  </Link>
                </>
              )}
            </div>
          </div>
          <div className="flex items-center">
            {isSignedIn ? (
              <div className="flex items-center space-x-4">
                <span className="text-white text-sm">{user?.firstName || 'User'}</span>
                <button
                  onClick={() => signOut(() => window.location.href = "/")}
                  className="bg-white text-indigo-600 px-4 py-2 rounded-md text-sm font-medium"
                >
                  Sign Out
                </button>
              </div>
            ) : (
              <Link href="/sign-in">
                <button className="bg-white text-indigo-600 px-4 py-2 rounded-md text-sm font-medium">
                  Sign In
                </button>
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
